<div class="details-menu">
    @if (!readonly && hasWarning) {
        <div class="icons-container">
            <button
                mat-mini-fab
                class="warn-button small blink"
                aria-label="Brouillons de mail en attente"
                matTooltip="Brouillons de mail en attente"
                matTooltipPosition="below"
                (click)="onDisplayDraftEmail()">
                <fa-icon [icon]="warningIcon"></fa-icon>
            </button>
        </div>
    }
    <div class="icons-container">
        <button
            mat-mini-fab
            class="primary-button small"
            aria-label="Accéder au premier dossier"
            matTooltip="Accéder au premier dossier"
            matTooltipPosition="below"
            (click)="onNavigate(NavigateType.First)">
            <fa-icon [icon]="firstIcon"></fa-icon>
        </button>
        <button
            mat-mini-fab
            class="primary-button small"
            aria-label="Accéder au dossier précédent"
            matTooltip="Accéder au dossier précédent"
            matTooltipPosition="below"
            (click)="onNavigate(NavigateType.Previous)">
            <fa-icon [icon]="nextIcon" rotate="180"></fa-icon>
        </button>
        <button
            mat-mini-fab
            class="primary-button small"
            aria-label="Accéder au dossier suivant"
            matTooltip="Accéder au dossier suivant"
            matTooltipPosition="below"
            (click)="onNavigate(NavigateType.Next)">
            <fa-icon [icon]="nextIcon"></fa-icon>
        </button>
        <button
            mat-mini-fab
            class="primary-button small"
            aria-label="Accéder au dernier dossier"
            matTooltip="Accéder au dernier dossier"
            matTooltipPosition="below"
            (click)="onNavigate(NavigateType.Last)">
            <fa-icon [icon]="lastIcon"></fa-icon>
        </button>
    </div>
    <div class="icons-container">
        @if (!readonly) {
            @if (userRights.get(Rights.AddFileToFolder)) {
                <button mat-mini-fab class="basic-button small" aria-label="Attacher un fichier" matTooltip="Attacher un fichier" matTooltipPosition="below" (click)="onAddFile()">
                    <fa-icon [icon]="attachmentIcon"></fa-icon>
                </button>
            }
            @if (userRights.get(Rights.SendEmail)) {
                <button mat-mini-fab class="basic-button small" aria-label="Envoyer un mail" matTooltip="Envoyer un mail" matTooltipPosition="below" (click)="onSendEmail()">
                    <fa-icon [icon]="emailIcon"></fa-icon>
                </button>
            }
            @if (userRights.get(Rights.SendSms)) {
                <button mat-mini-fab class="basic-button small" aria-label="Envoyer un SMS" matTooltip="Envoyer un SMS" matTooltipPosition="below" (click)="onSendSms()">
                    <fa-icon [icon]="smsIcon"></fa-icon>
                </button>
            }
            @if (userRights.get(Rights.AddComment)) {
                <button
                    mat-mini-fab
                    class="basic-button small"
                    aria-label="Ajouter un commentaire"
                    matTooltip="Ajouter un commentaire"
                    matTooltipPosition="below"
                    (click)="onAddComment()">
                    <fa-icon [icon]="commentIcon"></fa-icon>
                </button>
            }
            @if (userRights.get(Rights.ChangeStandByState)) {
                @if (isInStandbyState) {
                    <button
                        mat-mini-fab
                        class="basic-button small"
                        aria-label="Sortir le dossier de veille"
                        matTooltip="Sortir le dossier de veille"
                        matTooltipPosition="below"
                        (click)="removeFromStandByState()">
                        <fa-icon [icon]="endStandByIcon"></fa-icon>
                    </button>
                } @else {
                    <button
                        mat-mini-fab
                        class="basic-button small"
                        aria-label="Mettre le dossier en veille"
                        matTooltip="Mettre le dossier en veille"
                        matTooltipPosition="below"
                        (click)="setInStandByState()">
                        <fa-icon [icon]="standByIcon"></fa-icon>
                    </button>
                }
            }
            @if (userRights.get(Rights.ReminderCreate)) {
                <button mat-mini-fab class="basic-button small" aria-label="Ajouter un rappel" matTooltip="Ajouter un rappel" matTooltipPosition="below" (click)="onAddReminder()">
                    <fa-icon [icon]="addReminderIcon"></fa-icon>
                </button>
            }
            @if (userRights.get(Rights.ArchiveCreate)) {
                @if (isInWaitingArchivingState) {
                    <button
                        mat-mini-fab
                        class="basic-button small"
                        aria-label="Retirer le dossier de l'état en attente d'archivage"
                        matTooltip="Retirer le dossier de l'état en attente d'archivage"
                        matTooltipPosition="below"
                        (click)="removeFromWaitingArchivingState()">
                        <mat-icon>unarchive</mat-icon>
                    </button>
                } @else {
                    <button
                        mat-mini-fab
                        class="basic-button small"
                        aria-label="Placer le dossier en attente d'archivage"
                        matTooltip="Placer le dossier en attente d'archivage"
                        matTooltipPosition="below"
                        (click)="setInWaitingArchivingState()">
                        <mat-icon>archive</mat-icon>
                    </button>
                }

                <button
                    mat-mini-fab
                    class="basic-button small"
                    aria-label="Archiver le dossier"
                    matTooltip="Archiver le dossier"
                    matTooltipPosition="below"
                    (click)="onArchiving()">
                    <fa-icon [icon]="archivingIcon"></fa-icon>
                </button>
            }
        }
    </div>
    <div class="icons-container">
        @if (!readonly && userRights.get(Rights.FolderDelete)) {
            <button mat-mini-fab class="warn-button small" aria-label="Supprimer ce dossier" matTooltip="Supprimer ce dossier" matTooltipPosition="below" (click)="onDelete()">
                <fa-icon [icon]="trashIcon"></fa-icon>
            </button>
        }
    </div>
    <div class="icons-container">
        @if (userRights.get(Rights.FollowFolder)) {
            @if (isFollowed) {
                <button
                    mat-mini-fab
                    class="basic-button small"
                    aria-label="Arrêter de suivre le dossier"
                    matTooltip="Arrêter de suivre le dossier"
                    matTooltipPosition="below"
                    (click)="followFolder(false)">
                    <fa-icon [icon]="stopFollowFolderIcon"></fa-icon>
                </button>
            } @else {
                <button
                    mat-mini-fab
                    class="basic-button small"
                    aria-label="Suivre le dossier"
                    matTooltip="Suivre le dossier"
                    matTooltipPosition="below"
                    (click)="followFolder(true)">
                    <fa-icon [icon]="followFolderIcon"></fa-icon>
                </button>
            }
        }
    </div>
</div>
